import React from "react";
import styled from "styled-components";
import dayjs from "dayjs";
import * as R from "ramda";

import f from "../firebase.client";
import * as u from "../utils";
import * as T from "./Typography";
import Modal from "./Modal";
import TextArea from "./TextArea";
import * as UserCxt from "./UserContext";

const REASONS_FEED = [
  "Spam",
  "False information",
  "Violence",
  "Unauthorised sales",
  "Harassment",
  "Something else",
];

const USER_KEYS = ["id", "name", "firstName", "lastName", "imageSrc", "email"];

const FEED_KEYS = ["id", "assets", "editorContent", "post", "latest_reactions"];

export default function Report(props) {
  const userInfo = React.useContext(UserCxt.Context);
  const [reasons, setReasons] = React.useState([]);
  const [text, setText] = React.useState();
  const [resText, setResText] = React.useState("SUBMIT REPORT");
  const txtProps = {
    onChange: (e) => setText(e.target.value),
    hint: "Add a note",
    value: text,
  };

  return (
    <Modal
      onClose={props.onClose}
      title="Report Activity"
      buttonText={resText}
      onProceed={onSubmit}
    >
      <S.Container>
        <S.List>{REASONS_FEED.map(getOption)}</S.List>
        <TextArea {...txtProps} />
      </S.Container>
    </Modal>
  );

  function getOption(elm) {
    const isSelect = reasons.includes(elm);
    const subProps = { key: elm, onClick, isSelect };

    return (
      <S.Goal {...subProps}>
        <T.CM>{elm}</T.CM>
      </S.Goal>
    );

    function onClick() {
      setReasons((prev) => {
        if (!prev.includes(elm)) return prev.concat(elm);
        return prev.filter((sub) => sub !== elm);
      });
    }
  }

  async function onSubmit() {
    const payload = {
      id: u.getRandomStr(28),
      createdAt: dayjs().unix(),
      feed: R.pick(FEED_KEYS, props),
      link: props.link || "",
      reasons: reasons,
      reporter: R.pick(USER_KEYS, userInfo),
      text: text?.trim() || "",
      type: props.type || "feed",
      user: await getUserInfo(),
    };

    await f.firestore().collection("reports").doc(payload.id).set(payload);
    setResText("THANK YOU");
    await u.pause(1300);
    if (props.onClose) props.onClose();
  }

  async function getUserInfo() {
    const maybeId = props?.actor?.id;
    const userRef = f.firestore().collection("users").doc(maybeId);
    const info = (await userRef.get()).data();
    return R.pick(USER_KEYS, info);
  }
}

const S = {};

S.Container = styled.div`
  padding: 10px 20px;
`;

S.List = styled.ul`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 40px;
`;

S.Goal = styled.li`
  align-items: center;
  background-color: ${(p) => (p.isSelect ? u.colours.teal : "transparent")};
  border: 1px solid
    ${(p) => (p.isSelect ? u.colours.teal : "rgba(65, 65, 67, 0.4)")};
  border-radius: 100px;
  cursor: pointer;
  display: flex;
  margin: 5px 10px 5px 0;
  padding: 5px 20px 5.5px;
  white-space: nowrap;
  p {
    color: ${(p) => p.isSelect && u.colours.white};
  }
  @media ${u.device.tablet} {
    padding: 7.5px 20px 8.5px;
    :hover {
      opacity: 0.4;
    }
  }
`;
